export const CONTENT_RECOMMENDATION_MEDIA_TYPES = new Set([
  "image",
  "video",
  "carousel",
]);

export const getContentRecommendationKey = ({ mediaType, text }) =>
  `${mediaType}\0${text}`;

export const isCarouselItem = (item) =>
  item?.isCarousel === true &&
  item?.carouselImages &&
  Array.isArray(item.carouselImages) &&
  item.carouselImages.length > 0;

export const getMediaItemIdentifier = (item) => {
  if (isCarouselItem(item)) {
    const firstUrl = item.carouselImages[0]?.url || item.url;
    return firstUrl || `carousel_${item.carouselImages.length}`;
  }
  return item?.url || "";
};

export const getValidMediaUrls = (mediaUrls) =>
  (mediaUrls || []).filter(
    (item) =>
      item != null &&
      (item.url ||
        (item.isCarousel === true &&
          item.carouselImages &&
          Array.isArray(item.carouselImages)))
  );

export const buildMediaUrlsSignature = (mediaUrls) => {
  const parts = getValidMediaUrls(mediaUrls).map(getMediaItemIdentifier);
  return [...parts].sort().join("\n");
};

const getMediaUrlsSignatureUrlSet = (signature) =>
  new Set(
    String(signature || "")
      .split("\n")
      .filter(Boolean)
  );

export const doesMediaUrlsSignatureOnlyAddUrls = ({ before, after }) => {
  const beforeSet = getMediaUrlsSignatureUrlSet(before);
  const afterSet = getMediaUrlsSignatureUrlSet(after);
  if (beforeSet.size === 0) return false;
  for (const url of beforeSet) {
    if (!afterSet.has(url)) return false;
  }
  return afterSet.size >= beforeSet.size;
};

export const filterValidContentRecommendations = (items) =>
  (items || []).filter(
    (row) =>
      row &&
      typeof row.text === "string" &&
      row.text.trim() !== "" &&
      CONTENT_RECOMMENDATION_MEDIA_TYPES.has(row.mediaType)
  );
